import React from "react";
import { Play } from "lucide-react";
import { VEVO_VIDEOS } from "../mock";
import { fbTrack } from "../lib/track";

const VideoCard = ({ video }) => {
  const thumb = `https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`;
  const watchUrl = `https://www.youtube.com/watch?v=${video.id}`;

  const handleClick = () => {
    fbTrack("ViewContent", {
      content_name: video.title,
      content_category: "Music Video",
      content_type: "video",
    });
  };

  return (
    <a
      href={watchUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="relative group block"
      aria-label={`Watch ${video.title} on YouTube`}
    >
      <div className="absolute -inset-1.5 bg-gradient-to-tr from-[#d4af37]/50 via-[#7c3aed]/30 to-[#d4af37]/40 rounded-2xl blur-lg opacity-60 group-hover:opacity-100 transition-opacity duration-500" />
      <div className="relative aspect-video w-full rounded-2xl overflow-hidden ring-1 ring-[#d4af37]/40 shadow-2xl bg-black">
        <img
          src={thumb}
          alt={video.title}
          onError={(e) => {
            e.currentTarget.src = `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
          }}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/60" />
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-gradient-to-b from-[#f5d67b] to-[#c8a13c] text-[#2a0e47] shadow-[0_0_40px_rgba(212,175,55,0.5)] transition-transform duration-500 group-hover:scale-110">
            <Play size={30} fill="currentColor" className="ml-1" />
          </span>
        </div>
        <span className="absolute bottom-3 right-4 text-[10px] tracking-[0.2em] uppercase text-white/70">
          Watch on YouTube
        </span>
      </div>
    </a>
  );
};

const Visual = () => {
  return (
    <section
      id="videos"
      className="relative bg-gradient-to-b from-[#0a0410] via-[#150826] to-[#0a0410] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute top-1/4 -right-40 w-[500px] h-[500px] rounded-full bg-[#6d28d9]/20 blur-[130px]" />
      <div className="absolute bottom-0 -left-40 w-[400px] h-[400px] rounded-full bg-[#d4af37]/10 blur-[130px]" />

      <div className="relative max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#c9a24a] tracking-[0.3em] uppercase text-xs mb-3">Official VEVO</p>
          <h2 className="heading-display gold-text text-4xl md:text-6xl">THE VIDEOS</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-10">
          {VEVO_VIDEOS.map((v) => (
            <VideoCard key={v.id} video={v} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Visual;
